import PropTypes from "prop-types";
import { Col, FormGroup, Input, Row } from "reactstrap";

import LabelTooltip from "../../../../../CommonElements/LabelTooltip";
import {
  Description,
  Enter,
  GroupDescriptionTooltipMessage,
  GroupName,
  GroupNameTooltipMessage,
} from "../../../../../utils/Constant";

const BasicDetails = ({ formValues, errors, handleInputChange }) => {
  return (
    <div>
      <Row>
        <Col sm="12" lg="6">
          <FormGroup>
            <LabelTooltip
              label={GroupName}
              tooltipText={GroupNameTooltipMessage}
              important={true}
            />
            <Input
              onChange={handleInputChange}
              value={formValues?.groupName}
              name="groupName"
              maxLength={100}
              type="text"
              placeholder={`${Enter} ${GroupName}`}
              invalid={!!errors.groupName}
            />
            <div className="invalid-feedback">{errors.groupName}</div>
          </FormGroup>
        </Col>

        <Col sm="12" lg="12">
          <FormGroup>
            <LabelTooltip
              label={Description}
              tooltipText={GroupDescriptionTooltipMessage}
              important={false}
            />
            <Input
              rows={4}
              onChange={handleInputChange}
              value={formValues.description}
              name="description"
              type="textarea"
              maxLength={500}
              placeholder={`${Enter} ${Description}`}
              invalid={!!errors.description}
            />
            <div className="invalid-feedback">{errors.description}</div>
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
};

BasicDetails.propTypes = {
  formValues: PropTypes.any,
  errors: PropTypes.any,
  handleInputChange: PropTypes.func.isRequired,
};

export default BasicDetails;
